import PageContainer from "../components/PageContainer";

export default function Error() {
  return (
    <PageContainer>
      <h2 class="pb-4 text-center text-3xl">404 Error</h2>
    </PageContainer>
  );
}